import { Component, OnInit } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Router, Scroll } from '@angular/router';
import { AuthenticationService, DataService, LocalService, MessageService, PropositionService } from '@app/services';
import { environment } from '@environment/environment';

import { Alert } from './models';
import { first } from 'rxjs';
import { VersionCheckService } from './services/version-check.service';

export let browserRefresh = false;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = environment.nameSite;
  loading: boolean;

  toast = new Alert();
  
  subscription: any;
  subscriptionLoad: any;
  subscriptionUser: any;

  utilisateur: any;

  constructor(
    private versionCheckService: VersionCheckService,
    public translate: TranslateService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private propositionService: PropositionService,
    private messageService: MessageService,
    private localService: LocalService,
    private router: Router
  ) {
    this.subscription = router.events.subscribe(
      (event) => {
          if (event instanceof Scroll) {
            //check if page has already been navigated
            browserRefresh = !router.navigated;

            //Si raffrachissement de la page, rechargement de l'utilisateur
            if(browserRefresh == false){
                //user
                this.refreshUser();
            }

            //A chaque changement de page
            this.eachTimeRefresh();
        }
    });

    // Register translation languages
    translate.addLangs(['en-US', 'es-ES', 'fr-FR', 'de-DE', 'pt-PT']);
    
    // Set default language
    translate.setDefaultLang('en-US');
  }

  //refresh user on page refresh
  refreshUser(){
    this.utilisateur = this.localService?.getJsonValue('currentUtilisateur');

    //lancer le refresh
    if(this.utilisateur) {
      this.authenticationService.reloadUser(this.utilisateur.id);
    }
  }

  eachTimeRefresh(){
    // Load Saved Language
    let lang = this.localService?.getJsonValue('currentLangue');
    let newLang = lang? lang : 'en-US';
    this.translate.use(newLang);

    this.subscriptionUser = this.authenticationService.currentUserValue
    .pipe(first())
    .subscribe(
      (res)=>{
        if(res){
            //rechargement des propositions
            this.loadPendingPropositions(res);

            //rechargement des messages non lus
            this.loadNotifications(res);
        }
      }
    );
  } 

  // Chargement des badges de propositions (source)
  loadPendingPropositions(user){
    this.propositionService.getPendingPropositions(user.id)
    .pipe(first())
    .subscribe(
      (res) => {  
        if(res) {
          //pub
          this.dataService.changeMessage('counts', res);
        }
      });
  }

  // Chargement des alertes dans les messages (source)
  loadNotifications(user) {
    let body = {
      dst_id: user.id
    };
    this.messageService.getUnreadMessagesByDestinataire(body)
    .pipe(first())
    .subscribe(
      res => {
        if(res) {
          //pub
          this.dataService.changeMessage('notif', res);
        }
      }
    );
  }

  // detecte changements dans le loading status
  subLoading(){
    this.subscriptionLoad = this.dataService.currentState
    .pipe(first())
    .subscribe(
      loading => this.loading = loading
    );
  }

  async ngOnInit(): Promise<void> {
    // Vérification de la version pour rafraîchir le cache si nécessaire
    this.versionCheckService.checkForVersionUpdate();

    this.subLoading();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionLoad.unsubscribe();
    this.subscriptionUser.unsubscribe();
  }
}
